@if (
  {
    stepInfo: currentStepInfo$ | async
  };
  as STATE
) {
  <section class="onboarding-layout">
    <aside class="onboarding-layout__aside">
      <img
        [ngSrc]="'assets/images/bg-login-img.png'"
        alt="image de fond"
        class="onboarding-layout__aside__bg-img"
        fill="true"
        priority="true"
      />
      @if (STATE.stepInfo) {
        <div class="onboarding-layout__aside-content">
          <h2 class="onboarding-layout__aside-content__title">
            {{ STATE.stepInfo.title }}
          </h2>
          <p class="onboarding-layout__aside-content__description">
            {{ STATE.stepInfo.description }}
          </p>
        </div>
      }
    </aside>

    <main class="onboarding-layout__main">
      <div class="onboarding-layout__main-content">
        <router-outlet></router-outlet>

        <footer
          class="onboarding-layout__main-footer"
          aria-label="Login footer"
        >
          <app-copyright />
        </footer>
      </div>
    </main>
  </section>
}
